define(['angular'], function(angular) {


    /**
     * @class multiStoresService
     */
    function MultiStoresService(storesGroupProvider) {
        var self = this;

        /**
         * Update or create a group of stores
         * @param  {Integer} id   Order id
         * @param  {Object} groupData order.storesGroup object: { id, name, rate }
         * @return {Object} {id, name, rate} Updated values
         */
        self.updateStoresGroup = function updateStoresGroup(id, groupData) {
            return storesGroupProvider
                .createUpdate({ id: id, name: groupData.name, rate: groupData.rate })
                .then(function(res) {
                    return res;
                });
        };

        self.deleteStoresGroup = function (id) {
            return storesGroupProvider.delete(id).then(function(res) { return res });
        }

        return self;
    }

    MultiStoresService.$inject = ['storesGroup'];

    angular.module('app.bdc.common.multiStoresService', []).factory('multiStoresService', MultiStoresService);
});
